import { Button, UIHeading4, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ILocationSubscriptionProps {
  onClick: () => void;
}

export const LocationSubscription = ({ onClick }: ILocationSubscriptionProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <UIHeading4>Подпишитесь на объявления в этой локации</UIHeading4>
        <div className={styles['description']}>
          <UIText1>Мы сообщим, как только поблизости появится что‑нибудь новенькое</UIText1>
        </div>
        <Button theme="fill_primary" size="XS" onClick={onClick}>
          Подписаться
        </Button>
      </div>
    </div>
  );
};
